export interface FeatureFlagProps {
    [key: string]: boolean;
}

export enum FeatureFlag {
    contextr = 'contextr',
    editorialErrors = 'editorialerrors',
    kraken = 'kraken',
    lilo = 'lilo',
    payment = 'payment',
    registration = 'registration',
}

export interface SettingsDataPayload {
    featureFlags: FeatureFlagProps[];
}

export interface State {
    featureFlags: FeatureFlagProps[];
}
